function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import React from 'react';
import cx from 'classnames';
import styles from "./TabList.less";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function TabLists(props) {
  var _selected$sortItem;
  var data = props.data,
    selected = props.selected,
    onChange = props.onChange;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.comprehensiveSort) && /*#__PURE__*/_jsxs("div", {
      className: styles.filterDown,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.downTitle,
        onClick: function onClick() {
          return setVisible(!visible);
        },
        children: [/*#__PURE__*/_jsx("span", {
          children: selected === null || selected === void 0 || (_selected$sortItem = selected['sortItem']) === null || _selected$sortItem === void 0 ? void 0 : _selected$sortItem.text
        }), /*#__PURE__*/_jsx("i", {
          className: cx(_defineProperty({}, styles.up, visible))
        })]
      }), visible && /*#__PURE__*/_jsx("div", {
        className: styles.downOptions,
        children: data === null || data === void 0 ? void 0 : data.comprehensiveSort.map(function (item) {
          return /*#__PURE__*/_jsx("div", {
            className: cx(styles.downItem, _defineProperty({}, styles.active, (selected === null || selected === void 0 ? void 0 : selected['sortItem'].id) === item.id)),
            onClick: function onClick() {
              onChange({
                sortItem: item
              });
              setVisible(false);
            },
            children: item.text
          }, item.id);
        })
      })]
    }), (data === null || data === void 0 ? void 0 : data.diseaseDomainList) && /*#__PURE__*/_jsx("div", {
      className: styles.diseaseTagList,
      children: data === null || data === void 0 ? void 0 : data.diseaseDomainList.map(function (item) {
        var _selected$diseaseDoma;
        return /*#__PURE__*/_jsx("div", {
          className: cx(styles.diseaseTag, _defineProperty({}, styles.active, (selected === null || selected === void 0 || (_selected$diseaseDoma = selected['diseaseDomain']) === null || _selected$diseaseDoma === void 0 ? void 0 : _selected$diseaseDoma.diseaseDomainId) === item.diseaseDomainId)),
          onClick: function onClick() {
            var _selected$diseaseDoma2;
            if ((selected === null || selected === void 0 || (_selected$diseaseDoma2 = selected['diseaseDomain']) === null || _selected$diseaseDoma2 === void 0 ? void 0 : _selected$diseaseDoma2.diseaseDomainId) === item.diseaseDomainId) {
              onChange({
                diseaseDomain: {}
              });
              return;
            }
            onChange({
              diseaseDomain: item
            });
          },
          children: item.diseaseDomainName
        }, item.diseaseDomainId);
      })
    })]
  });
}